/**
 * Hugeicons glyph data for the traffic-source badges in "How they found you",
 * shared by the native and web screens (each renders it with its own
 * `HugeIcon`). `share` and `tabbio` are absent on purpose: they use the app's
 * canonical ShareIcon and the Tabbio mark instead.
 */
import {
  BingIcon,
  CopyLinkIcon,
  FacebookIcon,
  GithubIcon,
  GlobeIcon,
  GoogleIcon,
  InstagramIcon,
  Link01Icon,
  LinkedinIcon,
  Mail01Icon,
  NewTwitterIcon,
  NewsIcon,
  QrCodeIcon,
  RedditIcon,
  Search01Icon,
  SnapchatIcon,
  Store01Icon,
  TagIcon,
  TelegramIcon,
  TiktokIcon,
  WhatsappIcon,
  YoutubeIcon,
} from '@hugeicons/core-free-icons';
import type { HugeIconData } from '../icons/HugeIcon.types';
import type { TrafficSourceIconKey } from '../../lib/cv-analytics-labels';

export const TRAFFIC_SOURCE_HUGEICONS: Record<
  Exclude<TrafficSourceIconKey, 'share' | 'tabbio'>,
  HugeIconData
> = {
  google: GoogleIcon,
  bing: BingIcon,
  search: Search01Icon,
  linkedin: LinkedinIcon,
  whatsapp: WhatsappIcon,
  x: NewTwitterIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  telegram: TelegramIcon,
  tiktok: TiktokIcon,
  snapchat: SnapchatIcon,
  youtube: YoutubeIcon,
  reddit: RedditIcon,
  github: GithubIcon,
  business: Store01Icon,
  email: Mail01Icon,
  qr: QrCodeIcon,
  copy: CopyLinkIcon,
  link: Link01Icon,
  news: NewsIcon,
  tag: TagIcon,
  website: GlobeIcon,
};
